import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import TextField from '@material-ui/core/TextField'
import ErrorBoundary from '../ErrorBoundary'
import { convertHarfCharacter } from '../../utility'

function stringDistance (str1, str2) {
  const reg = /\s+/g
  return str1.replace(reg, '') === str2.replace(reg, '') ? 0 : 1
}

const SuggestingSelector = React.forwardRef(function _ (props, ref) {
  const objects = props.objects
  const id2object = useRef(new Map(objects.map(obj => [obj.id, obj])))
  const defaultObj = props.value ? id2object.current.get(props.value) : null
  const distanceList = objects.map((obj) => [stringDistance(props.word, obj[props.propertyName]), obj])
  const suggestedObj = distanceList.sort((d1, d2) => d1[0] - d2[0])[0][1]

  const [value, setValue] = useState(defaultObj ? defaultObj.id : suggestedObj.id)

  useEffect(() => {
  }, [])

  return (
    <>
      {props.readonly
        ? (
        <TextField
          ref={ref}
          variant="standard"
          label={props.label}
          placeholder=""
          defaultValue={defaultObj ? defaultObj[props.propertyName] : '※未選択'}
          className="w-100"
          disabled={props.readonly}
          required={props.required}
          inputProps={{
            disabled: props.readonly
          }}
        />
          )
        : (
        <Autocomplete
          ref={ref}
          id="add-list"
          options={objects}
          getOptionLabel={(obj) => obj ? obj[props.propertyName] : ''}
          getOptionSelected={(obj) => obj !== ''}
          value={value ? id2object.current.get(value) : ''}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label={props.label}
              placeholder=""
              className="w-100"
              error={Boolean(props.options.error)}
              helperText={props.options.error || ''}
              required={props.required}
            />
          )}
          disablePortal={props.readonly}
          disableClearable={props.options.disableClearable || false}
          filterOptions={createFilterOptions({
            stringify: (option) => convertHarfCharacter(option[props.propertyName]) + convertHarfCharacter(option[props.propertyName], true) // 全角/半角に変換したものを両方検索対象として検索しやすくする
          })}
          onChange={(e, val) => {
            setValue(val ? val.id : null)
            if (props.options.onChange) {
              props.options.onChange(e, val)
            }
          }}
        />
          )}
      <input type="text" className="d-none" name={props.name} value={value || ''} readOnly />
    </>
  )
})
export default SuggestingSelector

SuggestingSelector.propTypes = {
  objects: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.number,
  propertyName: PropTypes.string,
  word: PropTypes.string,
  readonly: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.object
}
SuggestingSelector.defaultProps = {
  propertyName: 'name',
  word: '',
  options: {},
  required: false
}

$('.suggesting-selector').each((i, elem) => {
  const qel = $(elem)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <SuggestingSelector {...props}/>
    </ErrorBoundary>,
    elem
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
  return 0
})
